define('shared/initializer/form/adapters/mixins/ExistingMemberRedirectable',[
    'shared/lib/RSVP',
    'shared/util/registers/ActionProvider',
    'shared/initializer/form/constants',
    'shared/lib/cookie',
    'shared/remote/member/has'
], function(RSVP, ActionProvider, constants, cookie, hasMember) {
    'use strict';
    
    function Ctor() { }

    var ID = 'Open for existing member only';
    var LOGGED_OUT = 'Open for logged out only';
    var LOGGED_IN = 'Open for logged in only';
    var EITHER = 'Open for logged in or logged out';
    var registered = false;

    var loggedInRedirect = function (param, additionalParam) {
        if (!param) return RSVP.resolve();
        var me = additionalParam.form;
        var cmus = cookie.get('CMus');
        if(cmus && cmus.length > 0) {
            // redirection set as user is logged in
            me.nextPageUrl = param;
            return RSVP.resolve();
        } else {
            // logged in check failed complete with no redirect for logged in only,
            // other case will check email address
            return RSVP.resolve();
        }
    };

    var loggedOutRedirect = function (param, additionalParam) {
        if (!param) return RSVP.resolve();
        var me = additionalParam.form;
        var email = me.items.get(constants.FIELD.Email).$el.val();
        if (!email) { return RSVP.resolve(); }
        additionalParam.promise = new RSVP.Promise(function(resolve, reject){
            var newUser = function () {
                // completing with no redirect
                resolve();
            };
            var userExists = function () {
                // redirection set due to existing user
                me.nextPageUrl = param;
                resolve();
            };
            hasMember({email: email}).then(function(hasMember){
                if (hasMember) {
                    userExists();
                }
                else {
                    newUser();
                }
            }, reject);
        });
        return additionalParam.promise;
    };

    Ctor.prototype.doPageLoad = function () {
        if (!registered) {
            registered = true;
        } else {
            return RSVP.resolve();
        }

        var me = this;
        var provider = {
            id: ID,
            type: 'page',
            actions: { }
        };

        provider.actions[LOGGED_OUT] = function () {
            return loggedOutRedirect.apply(me, arguments);
        };
        provider.actions[LOGGED_IN] = function () {
            return loggedInRedirect.apply(me, arguments);

        };
        provider.actions[EITHER] = function () {
            var arg = arguments;
            return loggedInRedirect.apply(me, arg)
                .then(function () {
                    // arg[0] is param aka the url
                    if (me.nextPageUrl === arg[0]) {
                        return RSVP.resolve();
                    } else {
                        return loggedOutRedirect.apply(me, arg);
                    }
                });
        };
        ActionProvider.instance.register(provider);
        return RSVP.resolve();
    };

    return Ctor;

});
